"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
export const useKeybinds = () => {
  const $ = _c(83);
  const t = useTranslations("useKeybinds");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      action: "redirect",
      url: "/"
    };
    t1 = [["g", "d"], ["g", "h"]];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("gd.description");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      action: t0,
      help: {
        keys: t1,
        description: t2
      }
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      action: {
        action: "redirect",
        url: "/"
      }
    };
    t5 = {
      action: "redirect",
      url: "/stats"
    };
    t6 = [["g", "s"]];
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("gs.description");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = {
      action: t5,
      help: {
        keys: t6,
        description: t7
      }
    };
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t10;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      action: "redirect",
      url: "/activity"
    };
    t10 = [["g", "a"]];
    $[13] = t10;
    $[14] = t9;
  } else {
    t10 = $[13];
    t9 = $[14];
  }
  let t11;
  if ($[15] !== t) {
    t11 = t("ga.description");
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = {
      action: t9,
      help: {
        keys: t10,
        description: t11
      }
    };
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      action: "redirect",
      url: "/rewards"
    };
    t14 = [["g", "r"], ["g", "l"]];
    $[19] = t13;
    $[20] = t14;
  } else {
    t13 = $[19];
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t) {
    t15 = t("gl.description");
    $[21] = t;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t15) {
    t16 = {
      action: t13,
      help: {
        keys: t14,
        description: t15
      }
    };
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  let t18;
  let t19;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      action: {
        action: "redirect",
        url: "/rewards"
      }
    };
    t18 = {
      action: "redirect",
      url: "/profile"
    };
    t19 = [["g", "p"]];
    $[25] = t17;
    $[26] = t18;
    $[27] = t19;
  } else {
    t17 = $[25];
    t18 = $[26];
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t) {
    t20 = t("gp.description");
    $[28] = t;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t20) {
    t21 = {
      action: t18,
      help: {
        keys: t19,
        description: t20
      }
    };
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  let t23;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      action: "toggle",
      type: "persona"
    };
    t23 = [["t", "m"]];
    $[32] = t22;
    $[33] = t23;
  } else {
    t22 = $[32];
    t23 = $[33];
  }
  let t24;
  if ($[34] !== t) {
    t24 = t("tm.description");
    $[34] = t;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== t24) {
    t25 = {
      action: t22,
      help: {
        keys: t23,
        description: t24
      }
    };
    $[36] = t24;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  let t27;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      action: "toggle",
      type: "currency"
    };
    t27 = [["t", "c"]];
    $[38] = t26;
    $[39] = t27;
  } else {
    t26 = $[38];
    t27 = $[39];
  }
  let t28;
  if ($[40] !== t) {
    t28 = t("tc.description");
    $[40] = t;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== t28) {
    t29 = {
      action: t26,
      help: {
        keys: t27,
        description: t28
      }
    };
    $[42] = t28;
    $[43] = t29;
  } else {
    t29 = $[43];
  }
  let t30;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = [["/"], ["MODIFIER", "K"]];
    $[44] = t30;
  } else {
    t30 = $[44];
  }
  let t31;
  if ($[45] !== t) {
    t31 = t("search.description");
    $[45] = t;
    $[46] = t31;
  } else {
    t31 = $[46];
  }
  let t32;
  if ($[47] !== t31) {
    t32 = {
      help: {
        keys: t30,
        description: t31
      }
    };
    $[47] = t31;
    $[48] = t32;
  } else {
    t32 = $[48];
  }
  let t33;
  let t34;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      action: "help"
    };
    t34 = [["?"]];
    $[49] = t33;
    $[50] = t34;
  } else {
    t33 = $[49];
    t34 = $[50];
  }
  let t35;
  if ($[51] !== t) {
    t35 = t("shift?.description");
    $[51] = t;
    $[52] = t35;
  } else {
    t35 = $[52];
  }
  let t36;
  if ($[53] !== t35) {
    t36 = {
      action: t33,
      help: {
        keys: t34,
        description: t35
      }
    };
    $[53] = t35;
    $[54] = t36;
  } else {
    t36 = $[54];
  }
  let t37;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = [["j"], ["\u2190"]];
    $[55] = t37;
  } else {
    t37 = $[55];
  }
  let t38;
  if ($[56] !== t) {
    t38 = t("j.description");
    $[56] = t;
    $[57] = t38;
  } else {
    t38 = $[57];
  }
  let t39;
  if ($[58] !== t38) {
    t39 = {
      help: {
        keys: t37,
        description: t38
      }
    };
    $[58] = t38;
    $[59] = t39;
  } else {
    t39 = $[59];
  }
  let t40;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = [["k"], ["\u2192"]];
    $[60] = t40;
  } else {
    t40 = $[60];
  }
  let t41;
  if ($[61] !== t) {
    t41 = t("k.description");
    $[61] = t;
    $[62] = t41;
  } else {
    t41 = $[62];
  }
  let t42;
  if ($[63] !== t41) {
    t42 = {
      help: {
        keys: t40,
        description: t41
      }
    };
    $[63] = t41;
    $[64] = t42;
  } else {
    t42 = $[64];
  }
  let t43;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = [["Esc"]];
    $[65] = t43;
  } else {
    t43 = $[65];
  }
  let t44;
  if ($[66] !== t) {
    t44 = t("escape.description");
    $[66] = t;
    $[67] = t44;
  } else {
    t44 = $[67];
  }
  let t45;
  if ($[68] !== t44) {
    t45 = {
      help: {
        keys: t43,
        description: t44
      }
    };
    $[68] = t44;
    $[69] = t45;
  } else {
    t45 = $[69];
  }
  let t46;
  if ($[70] !== t12 || $[71] !== t16 || $[72] !== t21 || $[73] !== t25 || $[74] !== t29 || $[75] !== t3 || $[76] !== t32 || $[77] !== t36 || $[78] !== t39 || $[79] !== t42 || $[80] !== t45 || $[81] !== t8) {
    t46 = {
      gd: t3,
      gh: t4,
      gs: t8,
      ga: t12,
      gr: t16,
      gl: t17,
      gp: t21,
      tm: t25,
      tc: t29,
      search: t32,
      "shift?": t36,
      j: t39,
      k: t42,
      escape: t45
    };
    $[70] = t12;
    $[71] = t16;
    $[72] = t21;
    $[73] = t25;
    $[74] = t29;
    $[75] = t3;
    $[76] = t32;
    $[77] = t36;
    $[78] = t39;
    $[79] = t42;
    $[80] = t45;
    $[81] = t8;
    $[82] = t46;
  } else {
    t46 = $[82];
  }
  return t46;
};